const ONLIVE_MAINIMAGE = 'https://cdn.onlive.site/assets/images/ONLIVE.SITE_OAUTH_MAINIMAGE.webp';

const Cover = ({ imageUrl }) => {

  return (
          <div style={{overflow: 'hidden', height: "100%"}}>
            <img
              style={{height: '100%', width: '100%', objectFit: "cover"}}
              src={imageUrl ? imageUrl : ONLIVE_MAINIMAGE}
              alt={''}
            />
          </div>
  );
}

export default Cover;
